/**
 * Form alanının altındaki hata satırı (`useRecordEditor`: doğrulama ya da sunucunun 422'si). Alan
 * `fieldErrorProps(id, message)` (`lib/form/field-error.ts`) ile buna bağlanır; mesaj yoksa hiçbir şey çizilmez.
 */
export function FieldError({ id, message }: { id: string; message?: string | null }) {
  if (!message) return null
  return (
    <span id={`${id}-error`} role="alert" className="text-danger max-w-56 text-xs">
      {message}
    </span>
  )
}
